import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading;
export const getGroups = store => store[NAME].groups;
export const getUsers = store => store[NAME].users;
export const getTags = store => store[NAME].tags;